import type { Project } from '@altyor-kronos/shared-types';
import { usePolledResource } from '../../core/data/usePolledResource';
import { apiGet } from '../../core/data/restClient';

export interface ProjectDocState {
  project: Project | null;
  loading: boolean;
  error: Error | null;
}

/**
 * Read a single `projects/{id}` doc — the shell subscription behind
 * `/projects/:id` (`ProjectDetail.tsx`). A 404 becomes the "Project not
 * found" error for a missing doc.
 */
export function useProjectDoc(id: string | undefined): ProjectDocState {
  const { rows, loading, error } = usePolledResource<Project & { id: string }>(
    id ?? null,
    // Un 404 remonte tel quel : ApiError porte déjà un message traduit (#66).
    async () => [await apiGet<Project & { id: string }>(`/projects/${id}`)],
  );
  return { project: rows[0] ?? null, loading, error };
}
